var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.206,
    height: 19.609,
    viewBox: "0 0 20.206 19.609",
    className: "star-icon-opacity",
    style: {
      opacity: 0.2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M10,.646,7.661,5.452l-5.238.773a1.166,1.166,0,0,0-.635,1.982l3.789,3.739-.9,5.282a1.15,1.15,0,0,0,1.663,1.223l4.686-2.494,4.686,2.494a1.15,1.15,0,0,0,1.663-1.223l-.9-5.282,3.789-3.739a1.166,1.166,0,0,0-.635-1.982L14.4,5.452,12.06.646A1.142,1.142,0,0,0,10,.646Z",
    transform: "translate(-0.928 0.501)",
    fill: "#ffa200",
    stroke: "#cb8100",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOpacity);
export default __webpack_public_path__ + "static/media/starOpacity.38f7f37f425ca085063d5f6fcfc6e022.svg";
export { ForwardRef as ReactComponent };